export const SET_MONSTER = 'SET_MONSTER'
export const TOGGLE_LOADING = 'TOGGLE_LOADING'